<template>
  <div class="exchange-course">
    <!-- 换课列表-->
    <TheLoading :visible="isVisitLoad" />
    <van-sticky :offset-top="0">
      <HeaderNav
        :cardTitle="'更换商品'"
        :font-size="'big'"
        :info="{ isIndexHead: false, userid: stateUserId }"
        :istransparent="false"
        noHeaderModule
      />
      <!-- 更换课程筛选项-->
      <FilterList
        v-if="showFilter"
        :able-choose="ableChoose"
        :list="filterList"
        :tag-select-active="tagSelectActive"
        @change="handleChangeFilterItem"
        @open="handleOpenFilterItem"
      />
    </van-sticky>
    <template v-if="tabList.length > 0">
      <van-list
        v-model="loading"
        :error.sync="error"
        :finished="finished"
        finished-text="- 没有更多了 -"
        error-text="请求失败，点击重新加载"
        :immediate-check="false"
        offset="150"
        @load="getChangeCourseList"
      >
        <div class="chang-list">
          <course-tab-list :courseTabList="tabList" :cardType="queryCardType" />
        </div>
      </van-list>
    </template>
    <template v-else>
      <empty style="flex: 1" size="large"></empty>
    </template>
  </div>
</template>
<script>
import TheLoading from "@/components/TheLoading.vue";
import HeaderNav from "@/components/headerNav/index.vue";
import FilterList from "@/components/Filter.vue";
import courseTabList from "@/views/index/components/courseTabList.vue";
import empty from "@/components/empty.vue";
import {
  getSubPageList,
  getRecomSubPageList,
  getAddPriceBuyPageList,
  postChangeCourse,
  postRecomSubPageList,
} from "@/api/api";
import { mapState, mapMutations } from "vuex";
import WXJsBridge from "@xes/wxjsbridge/src";
import { cloneDeep } from "lodash";
import {
  formatData,
  setSelectType,
  transfromGoodsInfo,
} from "@/views/index/utils/formatData.js";
import { getAllRecomIdObj } from "../index/utils/tool";
import { getUrlParams } from "../../utils/getUrlParams";
import { appendStuCourseIds } from "@/common/script/log-helper";

const FILTER_CONFIG = [
  {
    type: "grade_id",
    typeName: "年级",
    isSelect: 0,
  },
  {
    type: "class_time",
    typeName: "时间",
    isSelect: 0,
  },
  {
    type: "time_slot",
    typeName: "时段",
    isSelect: 0,
  },
  {
    type: "learning_stage",
    typeName: "进度",
    isSelect: 0,
  },
  {
    type: "difficulty",
    typeName: "难度",
    isSelect: 0,
  },
  {
    type: "version",
    typeName: "版本",
    isSelect: 0,
  },
];

export default {
  name: "changeCourse",
  provide() {
    return {
      listType: "change", // 当为common时存在选择框
    };
  },
  components: {
    empty,
    TheLoading,
    HeaderNav,
    FilterList,
    courseTabList,
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      tabList: [
        //   { package_info: [] }
      ],
      filterList: cloneDeep(FILTER_CONFIG),
      tagSelectActive: [],
      beforeClassId: "",
      beforeCourseId: "",
      isVisitLoad: false,
      ableChoose: {},
      hasInitializedFilterOptions: false,
      pageTotal: 0,
      pageCount: 1,
      allCourseIds: [],
    };
  },
  computed: {
    ...mapState({
      stateUserId: (state) => state.userId,
      stateOriginParams: (state) => state.originParams,
      stateContCourseData: (state) => state.contCourseData,
      recList: (state) => state.recList,
    }),
    queryCardType() {
      return this.$route.query?.cardType;
    },
    isSimpleProduct() {
      // 是否是纯实物
      return (
        +this.stateOriginParams.product_type === 105 ||
        +this.stateOriginParams.product_type === 107
      );
    },
    isAddPriceBuy() {
      // 是否是加价购商品
      return this.stateOriginParams.isAddPriceBuy;
    },
    isSelectionModeCard() {
      return +this.stateOriginParams?.selection_mode === 2;
    },
    showFilter() {
      // 加价购商品没筛选
      if (this.isAddPriceBuy) {
        return false;
      }
      // 纯实物商品不展示筛选
      return (
        !this.isSimpleProduct &&
        this.filterList?.length > 0 &&
        Object.values(this.ableChoose || {}).some(
          (item) => Array.isArray(item) && item.length > 0
        )
      );
    },
  },
  async created() {
    if (this.isAddPriceBuy) {
      console.log("this.isAddPriceBuy--", this.isAddPriceBuy);
      await this.getAddPriceBuyCourseList();
    } else {
      this.initSelectionModeTagSelectActive();
      console.log("this.filterList--", this.filterList);
      await this.getChangeCourseList(true);
    }
  },
  mounted() {
    this.$xesLogger.loadMsg({
      ...appendStuCourseIds(
        {
          show_id: "show_u8ObLBe1",
          show_name: "筛选页面-曝光",
        },
        this.stateContCourseData
      ),
    });
    if (this.$isInApp) {
      WXJsBridge.setNavigationBar({
        hidden: 1,
      });
      this.xesAppStatusBarHeight = window.xesApp.getStatusBarHeight();
    }
    this.$nextTick(() => {
      document.documentElement.scrollTop = 0;
    });
    // 监听换为本课
    this.$EventBus.$on("selectCourse", (package_info) => {
      if (this.isAddPriceBuy) {
        this.handleChangeNowCourseAddPriceBuy(package_info);
      } else {
        this.handleChangeNowCourse(package_info);
      }
    });
  },
  beforeDestroy() {
    this.$EventBus.$off("selectCourse");
  },
  methods: {
    ...mapMutations([
      "SET_CONT_COURSE",
      "setIsLoad",
      "SET_IS_CHANGE_RAW_PRODUCT",
    ]),
    updateAbleChoose(ableChoose = {}) {
      this.ableChoose = cloneDeep(ableChoose);
      this.filterList = this.buildFilterList(this.ableChoose);
      this.hasInitializedFilterOptions = true;
    },
    buildChangeCourseListParams({
      page = this.pageCount,
      excludeType = "",
    } = {}) {
      const params = {
        page,
        course_id: this.stateOriginParams.course_id,
        product_type: this.stateOriginParams.product_type,
      };
      if (this.queryCardType === "raw") {
        // 原班课程比推荐课程多一个class_id参数
        params.class_id = this.stateOriginParams.class_id;
        params.is_group = this.stateOriginParams.is_group;
      }
      if (this.queryCardType === "recom") {
        params.sub_type = 2; //  二级页类型 1：范围扩科，2：配置扩科
        params.change_product_ids =
          this.stateOriginParams?.change_info?.change_product_ids || [];
        // 这里的 product_id 最原始的商品id，与更换的商品无关
        params.product_id =
          this.stateOriginParams?.origin_product_id ||
          this.stateOriginParams?.product_id;
      }
      this.tagSelectActive.forEach((item) => {
        if (item.id && item.type !== excludeType) {
          params[item.type] = item.id;
        }
      });
      return params;
    },
    buildFilterList(ableChoose = {}) {
      const filterList = cloneDeep(FILTER_CONFIG)
        .filter((item) => {
          return (
            Array.isArray(ableChoose[item.type]) && ableChoose[item.type].length
          );
        })
        .map((item) => {
          const selectedItem = this.tagSelectActive.find(
            (activeItem) => activeItem.type === item.type
          );
          const selectedOption = (ableChoose[item.type] || []).find(
            (option) => {
              return String(option.id) === String(selectedItem?.id || "");
            }
          );

          if (!selectedOption) {
            return item;
          }

          return {
            ...item,
            typeName: selectedOption.name,
            isSelect: 2,
            red: 2,
          };
        });

      const availableTypeList = filterList.map((item) => item.type);
      this.tagSelectActive = this.tagSelectActive
        .filter((item) => availableTypeList.includes(item.type))
        .map((item) => {
          const optionList = ableChoose[item.type] || [];
          const isValid = optionList.some((option) => {
            return String(option.id) === String(item.id || "");
          });
          return {
            ...item,
            id: isValid ? item.id : "",
          };
        });

      return filterList;
    },
    initSelectionModeTagSelectActive() {
      const selectionFilter = this.stateOriginParams?.selection_filter || {};
      this.tagSelectActive = [
        {
          type: "grade_id",
          id: selectionFilter.grade_id || "",
        },
        {
          type: "class_time",
          id: selectionFilter.class_time || "",
        },
      ].filter((item) => item.id);
    },
    async handleOpenFilterItem(tagType) {
      if (
        !this.isSelectionModeCard ||
        !["grade_id", "class_time"].includes(tagType)
      ) {
        return;
      }
      await this.fetchDynamicFilterOptions(tagType);
    },
    async fetchDynamicFilterOptions(tagType) {
      const params = this.buildChangeCourseListParams({
        page: 1,
        excludeType: tagType,
      });
      try {
        const { stat, data } =
          this.queryCardType === "raw"
            ? await getSubPageList(params)
            : await postRecomSubPageList(params);
        if (+stat && data) {
          this.updateAbleChoose(data.able_choose || {});
        }
      } catch (error) {
        console.log("fetchDynamicFilterOptions error--", error);
      }
    },
    // 筛选项点击
    handleChangeFilterItem(id, name, tagType) {
      console.log("handleChangeFilterItem", id, name, tagType);
      this.getChangeCourseList(true);
      this.$xesLogger.clickMsg({
        params: appendStuCourseIds(
          {
            click_id: "click_qftIIFb8",
            click_name: "筛选页面-筛选条件点击",
            respos_type: this.queryCardType === "raw" ? 1 : 2,
            [tagType]: name,
          },
          this.stateContCourseData
        ),
      });
    },
    // 组装更换课程所需参数
    getChangeCourseParams(package_info) {
      const { product_type, change_type, cnt_course_ids, union_course_id } =
        this.stateOriginParams;
      const params = {
        product_type,
        change_type,
      };
      if (+change_type === 3) {
        // 3 原班/推荐联报
        if (+product_type === 300) {
          // 更换 原班/推荐联报 混合品
          params.product_id = package_info.product_id;
        } else if (+product_type === 100) {
          // 更换 原班/推荐联报 课程
          params.course_id = package_info.product_list[0]?.id;
        } else if (+product_type === 107) {
          params.product_id = package_info.product_id;
        }
      } else if (+change_type === 2) {
        // 2 推荐续报
        params.course_id = package_info.product_list[0]?.id;
        params.class_id = package_info.product_list[0]?.extra_info?.class_id;
      } else if (+change_type === 1) {
        // 1 原班续报
        params.course_id = package_info.product_list[0]?.id;
        params.class_id = package_info.product_list[0]?.extra_info?.class_id;
        params.cnt_course_ids = cnt_course_ids;
        params.union_course_id = union_course_id || 0;
      }

      return params;
    },
    // 选完课程之后替换原有课程信息
    replacePackageInfo(data, selectType) {
      // 一：通过change_type判断，替换原有数据
      // 二：若原有状态已经选中，如果能选中那么默认选中，否则不选中
      let cloneState = cloneDeep(this.stateContCourseData);
      const { product_type, change_type, tab_list_index } =
        this.stateOriginParams;
      if (change_type === 3 && product_type === 100) {
        // 接口返回的package_info[0]替换原有package_info[1]
        cloneState[this.queryCardType === "raw" ? "cnt_list" : "recom_list"][
          tab_list_index
        ].package_info[1] = setSelectType(
          data.package_info[0],
          selectType === 2
        );
      }
      if (
        (change_type === 3 && product_type === 300) ||
        change_type !== 3 ||
        this.isSimpleProduct
      ) {
        // 接口返回的package_info替换原有package_info
        cloneState[this.queryCardType === "raw" ? "cnt_list" : "recom_list"][
          tab_list_index
        ].package_info = data.package_info.map((item) =>
          setSelectType(item, selectType === 2)
        );
      }
      if (change_type === 1) {
        // 接口返回的recom_list替换原有recom_list
        // cloneState.recom_list = data.recom_list;
        // for (let listItem of cloneState.recom_list) {
        //  formatData(listItem, false);
        // }
      }
      this.SET_CONT_COURSE(cloneState);
    },
    // 选择本课
    handleChangeNowCourse(package_info) {
      console.log("当前选中课程的数据---", package_info);
      // 由于更换课程属于二级页方法，所以逻辑统一在二级页这里处理
      const params = this.getChangeCourseParams(package_info);
      const {
        change_type,
        selectType,
        tab_list_index,
        product_type,
        package_info_index,
      } = this.stateOriginParams;
      postChangeCourse(params)
        .then((res) => {
          console.log("res---", res);
          if (+res.stat) {
            this.replacePackageInfo(
              {
                ...res.data,
                package_info: transfromGoodsInfo(
                  (res?.data?.package_info || []).map((item) => {
                    // origin_product_id 是为了 a商品换了b商品，b商品进入二级页面的时候，a商品还存在
                    if (this.queryCardType === "recom") {
                      if (!this.stateOriginParams?.origin_product_id) {
                        item.origin_product_id =
                          this.stateOriginParams?.product_id;
                      } else {
                        item.origin_product_id =
                          this.stateOriginParams?.origin_product_id;
                      }
                    }
                    return item;
                  })
                ),
              },
              selectType
            );
            this.SET_IS_CHANGE_RAW_PRODUCT(true);
            this.$router.replace({
              name: "index",
              query: {
                stuId: getUrlParams()?.stuId,
                isLoginFree: getUrlParams()?.isLoginFree,
              },
              params: {
                // 用来定位首页的数据并进行闪烁
                cardType: this.queryCardType,
                product_type,
                change_type,
                tab_list_index,
                package_info_index,
              },
            });
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .catch((err) => {
          console.log("err--", err);
          this.$toast.fail("换课失败");
        });
    },
    // 加价购课程  换为本课
    handleChangeNowCourseAddPriceBuy(package_info) {
      const {
        change_type,
        selectType,
        tab_list_index,
        product_type,
        package_info_index,
      } = this.stateOriginParams;
      // 直接用当前的课程替换首页的加价购的课程
      this.replacePackageInfo({ package_info: [package_info] }, selectType);
      this.$router.replace({
        name: "index",
        query: {
          stuId: getUrlParams()?.stuId,
          isLoginFree: getUrlParams()?.isLoginFree,
        },
        params: {
          // 用来定位首页的数据并进行闪烁
          cardType: this.queryCardType,
          product_type,
          change_type,
          tab_list_index,
          package_info_index,
        },
      });
    },
    /* 主课程 获取换课列表*/
    async getChangeCourseList(refresh) {
      if (this.isAddPriceBuy) return;
      if (refresh) {
        this.isVisitLoad = true;
        this.pageCount = 1;
        this.tabList = [];
        this.finished = false;
      } else {
        this.pageCount++;
      }
      const params = this.buildChangeCourseListParams();
      console.log("执行请求 params---", params);
      try {
        const { stat, msg, data } =
          this.queryCardType === "raw"
            ? await getSubPageList(params)
            : await postRecomSubPageList(params);
        if (+stat) {
          this.isVisitLoad = false;
          this.loading = false;
          this.error = false;
          if (data && Object.keys(data).length > 0) {
            if (!this.hasInitializedFilterOptions) {
              this.updateAbleChoose(data.able_choose || {});
            }
            this.pageTotal = data.page_total;
            transfromGoodsInfo(data.list || []).map((item) => {
              this.tabList.push({ package_info: [item] });
            });
            if (data.page >= this.pageTotal || this.pageTotal === 0) {
              this.finished = true;
            }
          }
        } else {
          this.isVisitLoad = false;
          this.loading = false;
          this.error = true;
        }
      } catch (error) {
        console.log("error--", error);
        this.isVisitLoad = false;
        this.loading = false;
        this.error = true;
      }
    },
    // 加价购课程 更换课程列表 没有分页和筛选
    async getAddPriceBuyCourseList() {
      try {
        const params = {
          ...this.stateOriginParams?.change_info,
          parent: this.stateOriginParams?.parent,
          rec_list: this.recList, // 添加 rec_list 参数
        };
        this.isVisitLoad = true;
        const { stat, data } = await getAddPriceBuyPageList(params);
        if (+stat) {
          this.isVisitLoad = false;
          this.loading = false;
          this.error = false;
          this.finished = true;
          if (data && Object.keys(data).length > 0) {
            const recomProductIdObj = getAllRecomIdObj(
              this.stateContCourseData.recom_list
            );
            data.list.map((item) => {
              const info = item.package_info?.map((info) => ({
                ...info,
                parent: item.parent, // 计价接口使用
                isAddPriceBuy: true,
              }));
              // 同时命中加价购配置和推荐配置，优先展示推荐配置，做去重处理
              if (!recomProductIdObj[item.product_key]) {
                this.tabList.push({
                  package_info: [...info],
                  isAddPriceBuy: true,
                });
              }
            });
          }
        } else {
          this.isVisitLoad = false;
          this.loading = false;
          this.error = true;
        }
      } catch (error) {
        console.log("error--", error);
        this.isVisitLoad = false;
        this.loading = false;
        this.error = true;
      }
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
.chang-list {
  padding: 0 12px;
}
</style>
